import React from "react";
import {Navigate, RouteObject} from "react-router-dom";
import LoginPage from "../LoginPage";
import ReachGuard from "../ReachGuard";
import ReachLayout from "../layout/ReachLayout";
import {reachUrls} from "../layout/menu-items";
import AssetsPage from "../pages/assets/AssetsPage";
import AudienceDetailPage from "../pages/audiences/AudienceDetailPage";
import AudiencesPage from "../pages/audiences/AudiencesPage";
import CampaignDetailPage from "../pages/campaigns/CampaignDetailPage";
import CampaignsPage from "../pages/campaigns/CampaignsPage";
import CardPaymentsRetryPage from "../pages/payments/card-payments-retry/CardPaymentsRetryPage";
import PaymentMethodDisplayPage from "../pages/payments/payment-method-display/PaymentMethodDisplayPage";
import DashboardPage from "../pages/dashboard/DashboardPage";
import GlossaryPage from "../pages/glossary/GlossaryPage";
import PromosPage from "../pages/promos/PromosPage";
import SegmentsPage from "../pages/segments/SegmentsPage";
import SnippetFormPage from "../pages/snippets/SnippetFormPage";
import SnippetsPage from "../pages/snippets/SnippetsPage";
import TemplateFormPage from "../pages/templates/TemplateFormPage";
import TemplatesPage from "../pages/templates/TemplatesPage";
import TriggerFormPage from "../pages/triggers/TriggerFormPage";
import TriggersPage from "../pages/triggers/TriggersPage";

export const reachRoutes: RouteObject[] = [
  {path: "/login", element: <LoginPage />},
  {
    element: (
      <ReachGuard>
        <ReachLayout />
      </ReachGuard>
    ),
    children: [
      {index: true, element: <Navigate to={reachUrls.dashboard} replace />},
      {path: reachUrls.dashboard, element: <DashboardPage />},
      {path: reachUrls.templates, element: <TemplatesPage />},
      {path: reachUrls.templatesNew, element: <TemplateFormPage />},
      {path: reachUrls.templateById, element: <TemplateFormPage />},
      {path: reachUrls.snippets, element: <SnippetsPage />},
      {path: reachUrls.snippetsNew, element: <SnippetFormPage />},
      {path: reachUrls.snippetById, element: <SnippetFormPage />},
      {path: reachUrls.assets, element: <AssetsPage />},
      {path: reachUrls.triggers, element: <TriggersPage />},
      {path: reachUrls.triggersNew, element: <TriggerFormPage />},
      {path: reachUrls.triggerById, element: <TriggerFormPage />},
      {path: reachUrls.glossary, element: <GlossaryPage />},
      {path: reachUrls.segments, element: <Navigate to={reachUrls.marketingSegments} replace />},
      {path: reachUrls.marketingSegments, element: <SegmentsPage key="marketing" pageKind="marketing" />},
      {path: reachUrls.validationSegments, element: <SegmentsPage key="validation" pageKind="validation" />},
      {path: reachUrls.audiences, element: <AudiencesPage />},
      {path: reachUrls.audienceDetail, element: <AudienceDetailPage />},
      {path: reachUrls.campaigns, element: <CampaignsPage />},
      {path: reachUrls.campaignDetail, element: <CampaignDetailPage />},
      {path: reachUrls.promos, element: <PromosPage />},
      {path: reachUrls.payments, element: <Navigate to={reachUrls.cardPaymentsRetry} replace />},
      {path: reachUrls.cardPaymentsRetry, element: <CardPaymentsRetryPage />},
      {path: reachUrls.paymentMethodDisplay, element: <PaymentMethodDisplayPage />},
    ],
  },
];
